import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import type { ServiceCategoryFilter } from "./mockData";
import { useServiceCategoryPillOptions } from "../../hooks/useServiceCategoryPillOptions";
import { SegmentPills } from "../shared/SegmentPills";

interface ServicesCategoryPillsProps {
  value: ServiceCategoryFilter;
  onChange: (value: ServiceCategoryFilter) => void;
  options?: { value: ServiceCategoryFilter; label: string }[];
}

export const ServicesCategoryPills = memo(function ServicesCategoryPills({
  value,
  onChange,
  options,
}: ServicesCategoryPillsProps) {
  const { t } = useTranslation();
  const defaultOptions = useServiceCategoryPillOptions();

  return (
    <SegmentPills
      value={value}
      options={options ?? defaultOptions}
      onChange={onChange}
      ariaLabel={t("analytics.aria.serviceCategories", "Service categories")}
    />
  );
});
